import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Switch, Redirect} from 'react-router-dom';
import cookie from 'react-cookies';
import Header from './general/Header/index_new';
import Footer from './general/Footer/index_new';
import {routes, ENV_CONFIG} from '../../config';
import {createRoute} from '../../utils/routeHelper';
import {checkTickerUrls} from '../../utils/common';
import Router from './Router';
import {selectedLang, getMenu, promotionalHeader} from '../actions';
import {LANGUAGE} from '../../constants/index';
import customStyles from '../../styles/modalStyle'
import Modal from '../components/general/Modal';
import {openPopup} from '../components/general/Modal/action';
import MainLoader from '../components/general/MainLoader';
import RedirectWithStatus from './HOC/redirectWithStatus';
import { browserName } from 'react-device-detect';
// import TransactionBotData from './general/TransactionBot/index';


class Main extends Component {
 constructor(props) {
   super(props);
   this.mainContentRef=null
   this.state = {
       pageLoading: true,
   }
 }

 componentDidMount() {
   this.loadHandler();
   this.setState({pageLoading: false});
   $(document).keydown(function (event) {
       if (event.keyCode == 123) { // Prevent F12
           return false;
       } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I
           return false;
       }
   });

   // Prevent Right Click
   // $(document).on("contextmenu", function (e) {
   //     e.preventDefault();
   // });


 }

 loadHandler = () => {
   const {selectedLang, getMenu, getMenus , promotionalHeader , commonContent: {
       menu, promotionHeader
     }} = this.props;
   let lang = LANGUAGE.EN;
   // if (__CLIENT__) {
   //   lang = window.location.pathname.split('/')[1].match(/en|hi/) || LANGUAGE.EN;
   // }
   selectedLang(lang);
   !getMenus.headerMenu && getMenu();
   !(promotionHeader && promotionHeader.code && promotionHeader.code == 200) && promotionalHeader();
   cookie.save('selectedLanguage', lang, {secure: true, sameSite: 'strict', httpOnly: true })
 };

 render() {
   const {
     modal: {
       showModal
     },
     commonContent: {
       currentSelected,
       menu,
       isLoading,
       promotionHeader
     }
   } = this.props;
   const {pageLoading} = this.state;
   let headerMenu = {},
     footerMenu = {};
   if (menu) {
     headerMenu = menu.headerMenu;
     footerMenu = menu.footerMenu;
   }
   let isLearnPage,
     isMarketingPage,redirectObj, isPlan, isBunny, isMaintenance, tranBot, isSipPage, isSipLandingPage, isGoalMarketing;
     let isIframeContent = true;
     let isOneSpan = false;

   if (__CLIENT__) {
     isLearnPage = window.location.href.indexOf("learn");
     isMaintenance = window.location.href.indexOf("maintenance");
     isMarketingPage = window.location.href.indexOf("marketing");
     isPlan = location.pathname.indexOf('kya-plan-hai');
     isBunny = window.location.href.indexOf("mf-bytes");
     tranBot = window.location.pathname;

     const referrer = document.referrer;
    if(referrer == 'https://distributor.hdfcfund.com/'){
      isIframeContent =  false;
    }
     
     if(window.location.pathname === '/learn/sip'){
       isSipPage=true;
     }
     
     if(window.location.pathname === '/sip'){
       isSipLandingPage=true;
     }
     if(window.location.pathname === '/goal'){
      isGoalMarketing=true;
    }
    if(window.location.pathname.includes("/RASP/info") || window.location.pathname.includes("/RASPIOS/info")){
      isOneSpan=true;
    }
   }

   let isWebViewData = true;
   if(browserName && (browserName.includes('WebView') || browserName.includes('WebKit'))){
     isWebViewData = false;
   }

   return (<Router>
     <div className={isWebViewData && isIframeContent && (checkTickerUrls() && promotionHeader && promotionHeader.data && promotionHeader.data.display) ? 'wrapper': 'new-wrapper'}>
       { __CLIENT__ && <script src='//cdnt.netcoresmartech.com/smartechclient.js' defer="defer" />}
       {__CLIENT__ && <script>
         {/* eslint-disable-next-line react/no-unescaped-entities */}
         smartech('create', 'ADGMOT35CHFLVDHBJNIG50K96BHPP5I34ISULH5H9GBV9GQN62M0' , "tin");
         {/* eslint-disable-next-line react/no-unescaped-entities */}
         smartech('register', '13c6ec67a88f4a8a080210ae39668624');
         {/* eslint-disable-next-line react/no-unescaped-entities */}
         smartech('identify', '');
         {/* eslint-disable-next-line react/no-unescaped-entities */}
         smartech('dispatch',1,{});
         </script>}
       {pageLoading && <MainLoader fromRoot={true}/>}
       {__CLIENT__ && <MainLoader isLoading={isLoading}/>}
       {((isMaintenance)) < 0 && isWebViewData && isIframeContent && !isOneSpan && <Header refProp={this.mainContentRef} headerMenu={headerMenu} {...this.props}/>}
       
         <div ref={ (ref) => this.mainContentRef=ref } className="body-content" id={isWebViewData && isIframeContent ? "main-content":""}>
             {
               isSipLandingPage ? <Redirect from={'/sip'} to={'/learners-corner/systematic-investment-plan'} /> : redirectObj ? <RedirectWithStatus exact strict status={301} key={redirectObj.id} from={redirectObj.from} to={redirectObj.to}/>
                : null
             }
             <Switch>
               {createRoute(routes)}
             </Switch>
           </div>
 
       { __CLIENT__ &&  isPlan < 0 &&  showModal && <Modal customStyle={customStyles}/>}
       {/* { __CLIENT__ &&  (-(isMarketingPage + isPlan + isMaintenance)/(isBunny)) < 0 && cookie.load('outsideCitizen') != "true" && <CallUs/>} */}
       {/* {tranBot !== "/transaction-bot" ?   <TransactionBotData /> : null} */}

       {/* {  (-(isMarketingPage + isPlan + isMaintenance)/(isBunny)) < 0 && <Footer currentLang={currentSelected} footerMenu={footerMenu} learn={isLearnPage}/>} */}
       { !isGoalMarketing && !isSipPage && isWebViewData && isIframeContent && !isOneSpan && <Footer currentLang={currentSelected} footerMenu={footerMenu} learn={isLearnPage}/>}
     </div>
   </Router>);
 }
}
const mapStateToProps = state => ({modal: state.modal, commonContent: state.commonContent , getMenus: state.commonContent.menu});

const mapDispatchToProps = (dispatch) => ({
 selectedLang: bindActionCreators(selectedLang, dispatch),
 getMenu: bindActionCreators(getMenu, dispatch),
 openPopup: bindActionCreators(openPopup, dispatch),
 promotionalHeader: bindActionCreators(promotionalHeader, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);